var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7244 7.07645C7.49074 7.0769 7.26431 6.99553 7.0844 6.84645L1.0844 1.84645C0.88018 1.67671 0.751756 1.4328 0.727376 1.16837C0.702996 0.903945 0.784658 0.640664 0.954397 0.436447C1.12414 0.23223 1.36805 0.103807 1.63247 0.0794268C1.8969 0.0550471 2.16018 0.136709 2.3644 0.306447L7.7244 4.78645L13.0844 0.466448C13.1867 0.383382 13.3044 0.32135 13.4307 0.283918C13.5571 0.246487 13.6896 0.234393 13.8206 0.248332C13.9516 0.262271 14.0786 0.301968 14.1942 0.365142C14.3099 0.428316 14.4119 0.513721 14.4944 0.616448C14.586 0.719269 14.6553 0.839895 14.6981 0.970769C14.7409 1.10164 14.7562 1.23994 14.7431 1.37701C14.7299 1.51407 14.6886 1.64694 14.6217 1.7673C14.5549 1.88766 14.4638 1.9929 14.3544 2.07645L8.3544 6.90645C8.16931 7.03196 7.9475 7.09182 7.7244 7.07645Z",
    fill: "#c4c4c4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow1);
export default __webpack_public_path__ + "static/media/DropdownArrow1.6946c708e8ea6e140d16df4719b806af.svg";
export { ForwardRef as ReactComponent };